/** @format */

import ApiService from "@/common/api.services";
import {
  FETCH_INTERNATIONAL_EVENTS,
  FETCH_INTERNATIONAL_TICKETS,
  FETCH_INTERNATIONAL_EVENTS_CATEGORIES,
  FETCH_INTERNATIONAL_EVENTS_CATEGORIES_BY_ID,
  INTERNATIONAL_TICKET_ONHOLD,
  BUY_INTERNATIONAL_TICKET,
  FETCH_GENERAL_SEARCH,
  TIXSTOCK_CONFIRMATION_FARE,
  TIXSTOCK_UPDATE_ORDER_STATUS,
  GET_ALL_CURRENCY_RATES,
  RELEASE_INTERNATIONAL_EVENT_HOLD_TICKET,
  SET_TIXSTOCK_NAV_CATEGORIES,
  SET_FEATURED_CATEGORIES,
  SET_TRENDING_CATEGORIES,
  SET_POPULAR_CATEGORIES,
  SET_ALL_CURRENCY_RATES
} from "./actions.type";
function buildCategoryTree(apiData) {
  const map = {};
  const roots = [];

  // normalize (ALL categories)
  apiData.forEach((item) => {
    map[item._id] = {
      _id: item._id,
      name: item.name,
      displayName: item.displayName || null,
      slug: item.slug,
      tixstockId: item.tixstockId,
      mainMenu: item.mainMenu || false,
      children: [],
    };
  });

  // build relations
  apiData.forEach((item) => {
    if (item.parentId && map[item.parentId._id]) {
      map[item.parentId._id].children.push(map[item._id]);
    }
  });

  // ONLY mainMenu === true will be top level
  apiData.forEach((item) => {
    if (item.mainMenu === true) {
      roots.push(map[item._id]);
    }
  });

  return roots;
}

function mapToCardCategory(item) {
  return {
    _id: item._id,
    title: item.displayName || item.name,
    slug: item.slug,
    tixstockId: item.tixstockId,
    imageUrl:item.featuredImage && item.featuredImage.url || item.image && item.image.url || ""
  };
}
const state = {
  // TOP NAV DATA
  allCurrencyRates: [],
 tixstockNavcategories: [],

  featuredCategories: [],
  trendingCategories: [],
  popularCategories: [],
};

const getters = {
  tixstockNavcategories(state) {
    return state.tixstockNavcategories;
  },
  featuredCategories(state) {
    return state.featuredCategories;
  },
  trendingCategories(state) {
    return state.trendingCategories;
  },
  popularCategories(state) {
    return state.popularCategories;
  },
   allCurrencyRates(state) {
    return state.allCurrencyRates;
  },
};

const actions = {
  [FETCH_INTERNATIONAL_EVENTS](state, params) {
    state.isLoading = true;
    return ApiService.getWithParams('tixstock/getEvents', {
      params,
    })
      .then(({ data }) => {
        return data.response.data;
      })
      .catch((error) => {
        return error.response;
      });
  },
  [FETCH_INTERNATIONAL_TICKETS](state, params) {
    state.isLoading = true;
    return ApiService.getWithParams('tixstock/getTickets', {
      params,
    })
      .then(({ data }) => {
        return data.response.data;
      })
      .catch((error) => {
        return error.response;
      });
  },
  [FETCH_GENERAL_SEARCH]({ commit }, { url, params }) {
    state.isLoading = true;
    return ApiService.getWithQueryParams(url, params)
      .then(({ data }) => {
        return data.response;
      })
      .catch((error) => {
        return error.response;
      });
  },
  [TIXSTOCK_CONFIRMATION_FARE]({ commit }, { url, params }) {
    state.isLoading = true;
    return ApiService.post(url, params)
      .then(({ data }) => {
        return data.response;
      })
      .catch((error) => {
        return error.response;
      });
  },
  [FETCH_INTERNATIONAL_EVENTS_CATEGORIES_BY_ID](state, params) {
    state.isLoading = true;
    return ApiService.getWithParams(`tixstock-category/${params}`)
      .then(({ data }) => {
        return data.response.data;
      })
      .catch((error) => {
        return error.response;
      });
  },
  [INTERNATIONAL_TICKET_ONHOLD](context, params) {
    return ApiService.post('tixstock/holdTickets', params)
      .then((response) => {
        return response.data.response.data;
      })
      .catch((error) => {
        return error.response.status;
      });
  },

  [RELEASE_INTERNATIONAL_EVENT_HOLD_TICKET](context, params) {
    return ApiService.post('/tixstock/releaseTickets', params)
      .then((response) => {
        return response.data.response.data;
      })
      .catch((error) => {
        return error.response.status;
      });
  },

  async [FETCH_INTERNATIONAL_EVENTS_CATEGORIES]({ commit }) {
    try {

      const { data } = await ApiService.getWithParams(
        '/tixstock-categories?skip=0&limit=999'
      );

      const apiCategories = data.response.data || [];

      // 1️⃣ NAV TREE (hover menu)
      commit('SET_TIXSTOCK_NAV_CATEGORIES', buildCategoryTree(apiCategories));

      // 2️⃣ FEATURED
      commit(
        'SET_FEATURED_CATEGORIES',
        apiCategories.filter((item) => item.isFeatured).map(mapToCardCategory)
      );

      // 3️⃣ TRENDING
      commit(
        'SET_TRENDING_CATEGORIES',
        apiCategories.filter((item) => item.isTrending).map(mapToCardCategory)
      );

      // 4️⃣ POPULAR
      commit(
        'SET_POPULAR_CATEGORIES',
        apiCategories.filter((item) => item.isPopular).map(mapToCardCategory)
      );
    } catch (error) {
      console.error('Tixstock categories error:', error);
      return error.response;
    }
  },
  [BUY_INTERNATIONAL_TICKET](context, params) {
    return ApiService.post('tixstock/buyTixstockTickets', params)
      .then((response) => {
        return response.data.response.data;
      })
      .catch((error) => {
        return error.response.status;
      });
  },
  [TIXSTOCK_UPDATE_ORDER_STATUS](context, params) {
    ApiService.setHeader();
    return ApiService.put('tixstock/updateTixstockBooking', params)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error.data;
      });
  },
  [GET_ALL_CURRENCY_RATES](context, params) {
    ApiService.setHeader();
    return ApiService.getWithParams('getAllCurrency')
      .then((response) => {
        context.commit('SET_ALL_CURRENCY_RATES', response.data.data);
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  },
};

const mutations = {
  SET_TIXSTOCK_NAV_CATEGORIES(state, payload) {
    state.tixstockNavcategories = payload;
  },

  SET_FEATURED_CATEGORIES(state, payload) {
    state.featuredCategories = payload;
  },
  SET_ALL_CURRENCY_RATES(state, payload) {
    state.allCurrencyRates = payload;
  },
  SET_TRENDING_CATEGORIES(state, payload) {
    state.trendingCategories = payload;
  },

  SET_POPULAR_CATEGORIES(state, payload) {
    state.popularCategories = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
